<!-- 时间轴组件 -->
<template>
<div class="time_line_lyout" :style="{height:(itemHeight*2+lineHeight*2+28)/baseSize+'rem'}">
    <div class="time_line_lyout_line"></div>
    <template v-for="(item,index) in list">
        <div v-if="item.type=='top'" class="time_line_lyout_item time_line_lyout_item_top" :style="{height:(itemHeight+lineHeight+28)/baseSize+'rem',left:itemWidth*item.position/baseSize+'rem'}" :key="index">
            <div :style="{height:itemHeight/baseSize+'rem'}" class="item_circle_content"><slot :item="item"></slot></div>
            <div :style="{height:lineHeight/baseSize+'rem'}" class="item_line" :class="{item_line2:!isPC}"></div>
            <div class="item_circle">
                <div class="item_circle_xin"></div>
            </div>
        </div>
        <div v-else class="time_line_lyout_item time_line_lyout_item_bottom" :style="{height:(itemHeight+lineHeight+28)/baseSize+'rem',left:(198+itemWidth*item.position)/baseSize+'rem'}" :key="index">
            <div class="item_circle">
                <div class="item_circle_xin"></div>
            </div>
            <div :style="{height:lineHeight/baseSize+'rem'}" class="item_line" :class="{item_line2:!isPC}"></div>
            <div :style="{height:itemHeight/baseSize+'rem'}" ><slot :item="item"></slot></div>
        </div>
    </template>
</div>
</template>

<script>
    export default {
        components: {
        },
        props:{
            dataList:{
                type:Array,
                default:()=>{
                    return []
                }
            },
            itemHeight:{//item的高度
                type:Number,
                default:100,
            },
            itemWidth:{//item的高度
                type:Number,
                default:400,
            },
            lineHeight:{//线的高度
                type:Number,
                default:60,
            },
        },
        computed: {
        },
        data() {
            return {
                list:[],
                topCount:0,
                bottomCount:0,
                //px转rem基础大小，1rem为100px
                baseSize:100,
                isPC:false,
            };
        },
        watch:{
        },
        created(){
            this.initData();
        },
        mounted(){
            this.isPC=this.$utils.isPC();
        },
        methods: {
            initData(){
                this.list=[];
                this.topCount=0;
                this.bottomCount=0;
                for (let index = 0; index < this.dataList.length; index++) {
                    let element = this.dataList[index];
                    if(element.type=="top"){
                        element.position=this.topCount;
                        this.topCount++;
                    }else{
                        element.position=this.bottomCount;
                        this.bottomCount++;
                    }
                    this.list.push(element);
                }
            },
        }
    }
</script>

<style lang="less" scoped>
@import url("./custom-time-line.less");
</style>
